import { useContext } from 'react';
import { UserContext } from '../../../context';
import { Page, PageTitle } from '../../../components';
import { isHomeowner } from '../../../helpers';
import { FavoriteOrdersList } from './favorite-orders-list';

export const FavoriteOrdersPage = () => {
  const { user } = useContext(UserContext);
  return (
    <Page
      title={`Favorite Orders`}
      showSideNav={!isHomeowner(user)}
      disableDesktopCollapse={isHomeowner(user)}
    >
      <PageTitle title={`Favorite Orders`} />
      <FavoriteOrdersList />
    </Page>
  );
};
